// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../../../shared/src/Store.bs.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var TypeUtils = require("../../../shared/src/types/TypeUtils.bs.js");
var ReactDom = require("react-dom");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Bool = require("relude/src/Relude_Bool.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Tuple = require("relude/src/Relude_Tuple.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var BrowserComponents_Icon = require("./BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("./BrowserComponents_Text.bs.js");
var BrowserComponents_Field = require("./BrowserComponents_Field.bs.js");
var BrowserComponents_Input = require("./BrowserComponents_Input.bs.js");
var BrowserComponents_Button = require("./BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");

function toEnum(param) {
  if (param !== 0) {
    if (param !== 1) {
      return ;
    } else {
      return /* Collapsed */1;
    }
  } else {
    return /* Expanded */0;
  }
}

function fromEnum(param) {
  if (param) {
    return 1;
  } else {
    return 0;
  }
}

var include = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

var eq = include.eq;

var bottom = include.bottom;

var succ = include.succ;

function toggle(param) {
  return Relude_Globals.$great$great(succ, (function (param) {
                return Relude_Option.getOrElse(bottom, param);
              }), param);
}

var Status_fromEnum = include.fromEnum;

var Status_toEnum = include.toEnum;

var Status_compare = include.compare;

var Status_Ord = include.Ord;

var Status_compareWithConversion = include.compareWithConversion;

var Status_compareReversed = include.compareReversed;

var Status_OrdReversed = include.OrdReversed;

var Status_compareAsInt = include.compareAsInt;

var Status_min = include.min;

var Status_max = include.max;

var Status_lessThan = include.lessThan;

var Status_lt = include.lt;

var Status_lessThanOrEq = include.lessThanOrEq;

var Status_lte = include.lte;

var Status_greaterThan = include.greaterThan;

var Status_gt = include.gt;

var Status_greaterThanOrEq = include.greaterThanOrEq;

var Status_gte = include.gte;

var Status_clamp = include.clamp;

var Status_between = include.between;

var Status_OrdRingExtensions = include.OrdRingExtensions;

var Status_OrdNamed = include.OrdNamed;

var Status_OrdBy = include.OrdBy;

var Status_Set = include.$$Set;

var Status_SetWithNone = include.SetWithNone;

var Status_Map = include.$$Map;

var Status_list = include.list;

var Status_array = include.array;

var Status_set = include.set;

var Status_setWithNone = include.setWithNone;

var Status_cardinality = include.cardinality;

var Status_top = include.top;

var Status_pred = include.pred;

var Status = {
  fromEnum: Status_fromEnum,
  toEnum: Status_toEnum,
  eq: eq,
  compare: Status_compare,
  Ord: Status_Ord,
  compareWithConversion: Status_compareWithConversion,
  compareReversed: Status_compareReversed,
  OrdReversed: Status_OrdReversed,
  compareAsInt: Status_compareAsInt,
  min: Status_min,
  max: Status_max,
  lessThan: Status_lessThan,
  lt: Status_lt,
  lessThanOrEq: Status_lessThanOrEq,
  lte: Status_lte,
  greaterThan: Status_greaterThan,
  gt: Status_gt,
  greaterThanOrEq: Status_greaterThanOrEq,
  gte: Status_gte,
  clamp: Status_clamp,
  between: Status_between,
  OrdRingExtensions: Status_OrdRingExtensions,
  OrdNamed: Status_OrdNamed,
  OrdBy: Status_OrdBy,
  $$Set: Status_Set,
  SetWithNone: Status_SetWithNone,
  $$Map: Status_Map,
  list: Status_list,
  array: Status_array,
  set: Status_set,
  setWithNone: Status_setWithNone,
  cardinality: Status_cardinality,
  top: Status_top,
  bottom: bottom,
  succ: succ,
  pred: Status_pred,
  toggle: toggle
};

var Vertical = {};

var Horizontal = {};

var Orientation = {
  Vertical: Vertical,
  Horizontal: Horizontal
};

function container(horizontalOrientation, param, verticalOrientation, windowRect) {
  var parentWidth = param.width;
  var parentRight = param.right;
  var parentLeft = param.left;
  var parentHeight = param.height;
  var parentBottom = param.bottom;
  return Curry._1(BrowserStyle.style, Relude_List.concat(Relude_List.mapOption(Relude_Globals.id, Curry._1(Relude_List.flatten, {
                          hd: Relude_List.pure(Relude_Option.map((function (param) {
                                      return Relude_Globals.$great$great((function (param) {
                                                    return Relude_Tuple.make2(verticalOrientation, param);
                                                  }), (function (param) {
                                                    if (param[0]) {
                                                      return BrowserStyle.top(BrowserStyle.px(Relude_Float.roundAsInt(parentBottom)));
                                                    } else {
                                                      return BrowserStyle.bottom(BrowserStyle.px(Relude_Float.roundAsInt(Relude_Float.subtract(param[1].bottom, parentBottom)) + Relude_Float.roundAsInt(parentHeight) | 0));
                                                    }
                                                  }), param);
                                    }), windowRect)),
                          tl: {
                            hd: Relude_List.map(Relude_Option.pure)(Curry._1(Relude_List.flatten, Relude_List.mapOption(Relude_Globals.id, Relude_List.pure(Relude_Option.map((function (param) {
                                                    return Relude_Globals.$great$great((function (param) {
                                                                  return Relude_Tuple.make2(horizontalOrientation, param);
                                                                }), (function (param) {
                                                                  switch (param[0]) {
                                                                    case /* Left */0 :
                                                                        return Relude_List.pure(BrowserStyle.right(BrowserStyle.px(Relude_Float.roundAsInt(Relude_Float.subtract(param[1].right, parentRight)))));
                                                                    case /* Center */1 :
                                                                        return {
                                                                                hd: BrowserStyle.left(BrowserStyle.px(Relude_Float.roundAsInt(parentLeft))),
                                                                                tl: {
                                                                                  hd: BrowserStyle.transform(BrowserStyle.translateX({
                                                                                            NAME: "calc",
                                                                                            VAL: [
                                                                                              "add",
                                                                                              BrowserStyle.pct(-50.0),
                                                                                              BrowserStyle.px(Relude_Float.roundAsInt(parentWidth) / 2 | 0)
                                                                                            ]
                                                                                          })),
                                                                                  tl: /* [] */0
                                                                                }
                                                                              };
                                                                    case /* Right */2 :
                                                                        return Relude_List.pure(BrowserStyle.left(BrowserStyle.px(Relude_Float.roundAsInt(parentLeft))));
                                                                    
                                                                  }
                                                                }), param);
                                                  }), windowRect))))),
                            tl: {
                              hd: Relude_List.pure(Relude_Option.map((function (param) {
                                          if (verticalOrientation) {
                                            return BrowserStyle.maxHeight(BrowserStyle.px(Relude_Float.roundAsInt(param.bottom) - Relude_Float.roundAsInt(parentBottom) | 0));
                                          } else {
                                            return BrowserStyle.maxHeight("none");
                                          }
                                        }), windowRect)),
                              tl: /* [] */0
                            }
                          }
                        })), {
                  hd: BrowserStyle.backgroundColor(/* Transparent */2),
                  tl: {
                    hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
                    tl: {
                      hd: BrowserStyle.boxShadow(/* Small */1),
                      tl: {
                        hd: BrowserStyle.overflowY(BrowserStyle.scroll),
                        tl: {
                          hd: BrowserStyle.position(BrowserStyle.fixed),
                          tl: {
                            hd: BrowserStyle.width(BrowserStyle.px(Relude_Float.roundAsInt(parentWidth))),
                            tl: {
                              hd: BrowserStyle.zIndex(Relude_Int.top),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

var contents = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.pct(100.0)),
      tl: /* [] */0
    });

var Styles = {
  container: container,
  contents: contents
};

function getParentRectFromDom(param_0) {
  return {
          TAG: /* GetParentRectFromDom */0,
          _0: param_0
        };
}

function updateParentRect(param_0) {
  return {
          TAG: /* UpdateParentRect */1,
          _0: param_0
        };
}

function updateWindowRect(param_0) {
  return {
          TAG: /* UpdateWindowRect */2,
          _0: param_0
        };
}

function reducer(param) {
  var parentElement = param[0];
  if (typeof parentElement === "number") {
    return Store.sideEffects(function (_state, dispatch) {
                var partial_arg = Relude_IO.pure(undefined);
                var partial_arg$1 = function (param) {
                  return Relude_Option.fold(partial_arg, (function (param) {
                                return Relude_Globals.$great$great((function (param) {
                                              return Relude_Globals.$great$great((function (param) {
                                                            return Relude_Globals.$great$great((function (prim) {
                                                                          return prim.getBoundingClientRect();
                                                                        }), DomUtils.Rect.fromDomRect, param);
                                                          }), updateWindowRect, param);
                                            }), dispatch, param);
                              }), param);
                };
                return Relude_IO.flatMap((function (param) {
                              return Relude_Globals.$great$great((function (param) {
                                            return Relude_Globals.$great$great((function (param) {
                                                          return Relude_Globals.$great$great((function (param) {
                                                                        return param.getElementsByTagName("body");
                                                                      }), (function (prim) {
                                                                        return Array.prototype.slice.call(prim);
                                                                      }), param);
                                                        }), Relude_Array.head, param);
                                          }), partial_arg$1, param);
                            }), Relude_IO.pure(document));
              });
  }
  switch (parentElement.TAG | 0) {
    case /* GetParentRectFromDom */0 :
        var parentElement$1 = parentElement._0;
        return Store.sideEffects(function (_state, dispatch) {
                    var partial_arg = Relude_IO.pure(undefined);
                    return Relude_IO.flatMap((function (param) {
                                  return Relude_Option.fold(partial_arg, (function (param) {
                                                return Relude_Globals.$great$great((function (param) {
                                                              return Relude_Globals.$great$great((function (param) {
                                                                            return Relude_Globals.$great$great((function (prim) {
                                                                                          return prim.getBoundingClientRect();
                                                                                        }), DomUtils.Rect.fromDomRect, param);
                                                                          }), updateParentRect, param);
                                                            }), dispatch, param);
                                              }), param);
                                }), Relude_IO.pure(parentElement$1));
                  });
    case /* UpdateParentRect */1 :
        var state = param[1];
        return Store.update({
                    modalElement: state.modalElement,
                    parentRect: Relude_Option.pure(parentElement._0),
                    windowRect: state.windowRect
                  });
    case /* UpdateWindowRect */2 :
        var state$1 = param[1];
        return Store.update({
                    modalElement: state$1.modalElement,
                    parentRect: state$1.parentRect,
                    windowRect: Relude_Option.pure(parentElement._0)
                  });
    
  }
}

function reducer$1(param, param$1) {
  return Relude_Globals.flip((function (param, param$1) {
                return Relude_Function.curry2(reducer, param, param$1);
              }), param, param$1);
}

var modalElementClassName = "dropdown-modal-element";

function isElementInModalDropdown(element) {
  if (element.classList.contains(modalElementClassName)) {
    return true;
  } else {
    return Relude_Option.fold(false, isElementInModalDropdown, Caml_option.nullable_to_opt(element.parentElement));
  }
}

function BrowserComponents_Dropdown$Base$Container(Props) {
  var additionalRefsOpt = Props.additionalRefs;
  var children = Props.children;
  var className = Props.className;
  var horizontalOrientation = Props.horizontalOrientation;
  var onClick = Props.onClick;
  var parentDomRef = Props.parentDomRef;
  var verticalOrientation = Props.verticalOrientation;
  var additionalRefs = additionalRefsOpt !== undefined ? additionalRefsOpt : /* [] */0;
  var match = ReactIO.useDomRef(undefined);
  var modalElement = document.createElement("div");
  var match$1 = Store.useStore({
        modalElement: (modalElement.classList.add(modalElementClassName), modalElement),
        parentRect: undefined,
        windowRect: undefined
      }, reducer$1);
  var dispatch = match$1[1];
  var match$2 = match$1[0];
  var windowRect = match$2.windowRect;
  var modalElement$1 = match$2.modalElement;
  var domRefs = ReactIO.useMemo3((function (containerDomRef, parentDomRef, additionalRefs) {
          return {
                  hd: containerDomRef,
                  tl: {
                    hd: parentDomRef,
                    tl: additionalRefs
                  }
                };
        }), [
        match[0],
        parentDomRef,
        additionalRefs
      ]);
  var getParentRectFromDom$1 = ReactIO.useMemo3((function (parentDomRef, getParentRectFromDom, dispatch) {
          var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                  
                }));
          return Relude_IO.flatMap((function (param) {
                        return Relude_Globals.$great$great((function (param) {
                                      return Relude_Globals.$great$great(getParentRectFromDom, dispatch, param);
                                    }), partial_arg, param);
                      }), parentDomRef);
        }), [
        parentDomRef,
        getParentRectFromDom,
        dispatch
      ]);
  var getWindowRectFromDom = ReactIO.useMemo2((function (getWindowRectFromDom, dispatch) {
          return Curry._2(Relude_IO.mapError, (function (prim) {
                        
                      }), Curry._1(dispatch, getWindowRectFromDom));
        }), [
        /* GetWindowRectFromDom */0,
        dispatch
      ]);
  DomUtils.useClickOutside(domRefs, (function (target) {
          var tmp;
          try {
            tmp = isElementInModalDropdown(target);
          }
          catch (exn){
            tmp = false;
          }
          if (tmp) {
            return Relude_IO.pure(undefined);
          } else {
            return Curry._1(onClick, /* OutsideDropdownClicked */2);
          }
        }));
  DomUtils.useOnWindowScroll(getParentRectFromDom$1);
  DomUtils.useOnWindowResize(getWindowRectFromDom);
  ReactIO.useHandledIOOnMount(undefined)(getParentRectFromDom$1);
  ReactIO.useHandledIOOnMount(undefined)(getWindowRectFromDom);
  ReactIO.useIOOnMount((function (param) {
          return Relude_Result.fold(Relude_IO.pure, (function (param) {
                        return Relude_Globals.$great$great(DomUtils.WebapiIO.removeChildFromBody, (function (param) {
                                      return Relude_IO.map((function (prim) {
                                                    
                                                  }), param);
                                    }), param);
                      }), param);
        }), undefined, DomUtils.WebapiIO.appendChildToBody(modalElement$1));
  var tmp = {
    ref: match[1],
    onClick: (function (param) {
        return Relude_Globals.$great$great((function (param) {
                      return Relude_Globals.$great$great((function (param) {
                                    return Relude_Globals.$$const(/* InsideDropdownClicked */1, param);
                                  }), onClick, param);
                    }), IOUtils.unsafeRunHandledAsync, param);
      })
  };
  var tmp$1 = Relude_Option.map((function (parentRect) {
          return BrowserStyle.Utils.extendBaseStyle(container(horizontalOrientation, parentRect, verticalOrientation, windowRect), Relude_Option.map((function (className) {
                            return Curry._2(className, parentRect, windowRect);
                          }), className));
        }), match$2.parentRect);
  if (tmp$1 !== undefined) {
    tmp.className = Caml_option.valFromOption(tmp$1);
  }
  return ReactDom.createPortal(React.createElement("div", tmp, React.createElement("div", {
                      className: contents
                    }, children)), modalElement$1);
}

var Container = {
  Styles: Styles,
  getParentRectFromDom: getParentRectFromDom,
  getWindowRectFromDom: /* GetWindowRectFromDom */0,
  updateParentRect: updateParentRect,
  updateWindowRect: updateWindowRect,
  reducer: reducer$1,
  modalElementClassName: modalElementClassName,
  isElementInModalDropdown: isElementInModalDropdown,
  make: BrowserComponents_Dropdown$Base$Container
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.maxWidth(BrowserStyle.pct(100.0)),
      tl: {
        hd: BrowserStyle.textAlign("left"),
        tl: /* [] */0
      }
    });

var Styles$1 = {
  container: container$1
};

function BrowserComponents_Dropdown$Base$Stateless(Props) {
  var additionalRefs = Props.additionalRefs;
  var buttonContent = Props.buttonContent;
  var buttonTabIndex = Props.buttonTabIndex;
  var children = Props.children;
  var className = Props.className;
  var containerClassName = Props.containerClassName;
  var containerDomRef = Props.containerDomRef;
  var horizontalOrientationOpt = Props.horizontalOrientation;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onFocus = Props.onFocus;
  var status = Props.status;
  var styleType = Props.styleType;
  var type_ = Props.type_;
  var verticalOrientationOpt = Props.verticalOrientation;
  var horizontalOrientation = horizontalOrientationOpt !== undefined ? horizontalOrientationOpt : /* Right */2;
  var verticalOrientation = verticalOrientationOpt !== undefined ? verticalOrientationOpt : /* Below */1;
  var match = ReactIO.useDomRef(undefined);
  var partial_arg = Curry._1(onClick, /* ButtonClicked */0);
  var tmp = {
    children: buttonContent,
    className: BrowserStyle.Utils.extendBaseStyle(container$1, className),
    disabled: BrowserStyle.Input.isDisabled(styleType),
    onClick: (function (param) {
        return Relude_Globals.$$const(partial_arg, param);
      }),
    ref: match[1]
  };
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (buttonTabIndex !== undefined) {
    tmp.tabIndex = Caml_option.valFromOption(buttonTabIndex);
  }
  if (type_ !== undefined) {
    tmp.type_ = Caml_option.valFromOption(type_);
  }
  var tmp$1;
  if (Curry._2(eq, /* Expanded */0, status)) {
    var tmp$2 = {
      children: children,
      horizontalOrientation: horizontalOrientation,
      onClick: onClick,
      parentDomRef: Relude_Option.getOrElse(match[0], containerDomRef),
      verticalOrientation: verticalOrientation
    };
    if (additionalRefs !== undefined) {
      tmp$2.additionalRefs = Caml_option.valFromOption(additionalRefs);
    }
    if (containerClassName !== undefined) {
      tmp$2.className = Caml_option.valFromOption(containerClassName);
    }
    tmp$1 = React.createElement(BrowserComponents_Dropdown$Base$Container, tmp$2);
  } else {
    tmp$1 = null;
  }
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Button.Base.make, tmp), tmp$1);
}

var Stateless = {
  Styles: Styles$1,
  make: BrowserComponents_Dropdown$Base$Stateless
};

function useExpandedState(statusOverride, collapseOnClickInside, disabled, onClick) {
  var match = ReactIO.useMappableState(function (param) {
        return Relude_Option.getOrElse(/* Collapsed */1, statusOverride);
      });
  var setStatus = match[1];
  var toggleStatus = Curry._1(setStatus, toggle);
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          return Relude_Bool.ifElse((function (param) {
                        return Curry._1(setStatus, (function (param) {
                                      return Relude_Globals.$$const(/* Collapsed */1, param);
                                    }));
                      }), Relude_IO.pure, param);
        }), disabled);
  var partial_arg = Relude_IO.pure(undefined);
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          return Relude_Option.fold(partial_arg, (function (param) {
                        return Relude_Globals.$great$great(Relude_Globals.$$const, setStatus, param);
                      }), param);
        }), statusOverride);
  var partial_arg$1 = Relude_Option.getOrElse((function (param) {
          return Relude_Globals.$great$great((function (prim) {
                        
                      }), Relude_IO.pure, param);
        }), onClick);
  var partial_arg$2 = function (param) {
    return Relude_IO.flatMap(partial_arg$1, param);
  };
  return {
          onClick: (function (param) {
              return Relude_Globals.$great$great((function (param) {
                            return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                          return Relude_IO.flatMap((function (x) {
                                                        switch (x) {
                                                          case /* ButtonClicked */0 :
                                                              return Relude_IO.map((function (param) {
                                                                            return Relude_Globals.$$const(x, param);
                                                                          }), toggleStatus);
                                                          case /* InsideDropdownClicked */1 :
                                                              if (collapseOnClickInside) {
                                                                return Relude_IO.map((function (param) {
                                                                              return Relude_Globals.$$const(x, param);
                                                                            }), Curry._1(setStatus, (function (param) {
                                                                                  return Relude_Globals.$$const(/* Collapsed */1, param);
                                                                                })));
                                                              } else {
                                                                return Relude_IO.pure(x);
                                                              }
                                                          case /* OutsideDropdownClicked */2 :
                                                              return Relude_IO.map((function (param) {
                                                                            return Relude_Globals.$$const(x, param);
                                                                          }), Curry._1(setStatus, (function (param) {
                                                                                return Relude_Globals.$$const(/* Collapsed */1, param);
                                                                              })));
                                                          
                                                        }
                                                      }), param);
                                        }), param);
                          }), partial_arg$2, param);
            }),
          status: match[0]
        };
}

function BrowserComponents_Dropdown$Base(Props) {
  var buttonContent = Props.buttonContent;
  var children = Props.children;
  var className = Props.className;
  var collapseOnClickInsideOpt = Props.collapseOnClickInside;
  var containerClassName = Props.containerClassName;
  var disabledOpt = Props.disabled;
  var horizontalOrientationOpt = Props.horizontalOrientation;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onFocus = Props.onFocus;
  var statusOverride = Props.statusOverride;
  var type_ = Props.type_;
  var verticalOrientationOpt = Props.verticalOrientation;
  var collapseOnClickInside = collapseOnClickInsideOpt !== undefined ? collapseOnClickInsideOpt : true;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var horizontalOrientation = horizontalOrientationOpt !== undefined ? horizontalOrientationOpt : /* Right */2;
  var verticalOrientation = verticalOrientationOpt !== undefined ? verticalOrientationOpt : /* Below */1;
  var match = useExpandedState(statusOverride, collapseOnClickInside, disabled, onClick);
  var status = match.status;
  var match$1 = Curry._2(BrowserStyle.Input.useInput(onFocus)(disabled), onBlur, undefined);
  var onBlur$1 = match$1.onBlur;
  var tmp = {
    buttonContent: Curry._1(buttonContent, status),
    children: children,
    horizontalOrientation: horizontalOrientation,
    onBlur: (function (param) {
        return Relude_Globals.$$const(onBlur$1, param);
      }),
    onClick: match.onClick,
    onFocus: match$1.onFocus,
    status: status,
    styleType: match$1.styleType,
    verticalOrientation: verticalOrientation
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (containerClassName !== undefined) {
    tmp.containerClassName = Caml_option.valFromOption(containerClassName);
  }
  if (type_ !== undefined) {
    tmp.type_ = Caml_option.valFromOption(type_);
  }
  return React.createElement(BrowserComponents_Dropdown$Base$Stateless, tmp);
}

var Base = {
  Container: Container,
  Stateless: Stateless,
  useExpandedState: useExpandedState,
  make: BrowserComponents_Dropdown$Base
};

var button = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.display(BrowserStyle.flexBox),
        tl: {
          hd: BrowserStyle.flexDirection(BrowserStyle.row),
          tl: {
            hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
            tl: {
              hd: BrowserStyle.position(BrowserStyle.relative),
              tl: {
                hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

function container$2(hover, isSelected) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.backgroundColor({
                    TAG: /* White */7,
                    _0: hover ? /* Dark */0 : /* Light */2
                  }),
              tl: {
                hd: BrowserStyle.color(isSelected ? ({
                          TAG: /* Teal */6,
                          _0: /* Medium */2
                        }) : /* CurrentColor */1),
                tl: {
                  hd: BrowserStyle.display(BrowserStyle.flexBox),
                  tl: {
                    hd: BrowserStyle.flex({
                          NAME: "num",
                          VAL: 1.0
                        }),
                    tl: /* [] */0
                  }
                }
              }
            });
}

function separator(showSeparator, size) {
  return Curry._1(BrowserStyle.merge, {
              hd: Curry._1(BrowserStyle.style, {
                    hd: BrowserStyle.alignItems(BrowserStyle.center),
                    tl: {
                      hd: BrowserStyle.flex({
                            NAME: "num",
                            VAL: 1.0
                          }),
                      tl: {
                        hd: BrowserStyle.Input.sizeToMarginSeparator(size),
                        tl: {
                          hd: BrowserStyle.Input.sizeToPaddingSeparator(size),
                          tl: /* [] */0
                        }
                      }
                    }
                  }),
              tl: {
                hd: showSeparator ? Curry._1(BrowserStyle.style, {
                        hd: BrowserStyle.borderBottomColor({
                              TAG: /* White */7,
                              _0: /* Dark */0
                            }),
                        tl: {
                          hd: BrowserStyle.borderBottomStyle("solid"),
                          tl: {
                            hd: BrowserStyle.borderBottomWidth(BrowserStyle.px(1)),
                            tl: /* [] */0
                          }
                        }
                      }) : Curry._1(BrowserStyle.style, /* [] */0),
                tl: /* [] */0
              }
            });
}

var text = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.textAlign("left"),
        tl: {
          hd: BrowserStyle.whiteSpace(BrowserStyle.nowrap),
          tl: /* [] */0
        }
      }
    });

var Styles$2 = {
  button: button,
  container: container$2,
  separator: separator,
  text: text
};

function BrowserComponents_Dropdown$Item(Props) {
  var children = Props.children;
  var className = Props.className;
  var icon = Props.icon;
  var iconColorOpt = Props.iconColor;
  var isSelected = Props.isSelected;
  var onClick = Props.onSelectItem;
  var selectedIcon = Props.selectedIcon;
  var showSeparatorOpt = Props.showSeparator;
  var size = Props.size;
  var iconColor = iconColorOpt !== undefined ? iconColorOpt : ({
        TAG: /* Grey */2,
        _0: /* Dark */1
      });
  var showSeparator = showSeparatorOpt !== undefined ? showSeparatorOpt : true;
  var match = ReactIO.useState(function (param) {
        return false;
      });
  var setHover = match[1];
  return React.createElement(BrowserComponents_Button.Base.make, {
              children: React.createElement("div", {
                    className: BrowserStyle.Utils.extendBaseStyle(container$2(match[0], isSelected), className)
                  }, React.createElement(BrowserComponents_FlexRow.make, {
                        className: separator(showSeparator, size),
                        children: null
                      }, Relude_Option.fold(null, (function (icon) {
                              return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Icon.make, {
                                              color: isSelected ? ({
                                                    TAG: /* Teal */6,
                                                    _0: /* Medium */2
                                                  }) : iconColor,
                                              icon: {
                                                TAG: /* Small */1,
                                                _0: icon
                                              },
                                              size: BrowserStyle.Input.sizeToIconSize(size)
                                            }), React.createElement(BrowserComponents_Spacer.make, {
                                              size: /* Small */3
                                            }));
                            }), icon), React.createElement(BrowserComponents_Text.make, {
                            className: text,
                            children: children
                          }), Relude_Option.fold(null, (function (icon) {
                              if (isSelected) {
                                return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                                size: /* Small */3
                                              }), React.createElement(BrowserComponents_Icon.make, {
                                                color: {
                                                  TAG: /* Teal */6,
                                                  _0: /* Medium */2
                                                },
                                                icon: {
                                                  TAG: /* Small */1,
                                                  _0: icon
                                                },
                                                size: BrowserStyle.Input.sizeToIconSize(size)
                                              }));
                              } else {
                                return null;
                              }
                            }), selectedIcon))),
              className: button,
              onClick: (function (param) {
                  return Relude_Globals.$$const(onClick, param);
                }),
              onMouseEnter: Curry._1(setHover, true),
              onMouseLeave: Curry._1(setHover, false)
            });
}

var Item = {
  Styles: Styles$2,
  make: BrowserComponents_Dropdown$Item
};

var container$3 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.pct(100.0)),
      tl: /* [] */0
    });

var itemListContainerBase = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display(BrowserStyle.block),
      tl: {
        hd: BrowserStyle.overflowY(BrowserStyle.scroll),
        tl: {
          hd: BrowserStyle.padding(BrowserStyle.zero),
          tl: /* [] */0
        }
      }
    });

function itemListContainer(size) {
  if (size !== 0) {
    return itemListContainerBase;
  } else {
    return Curry._1(BrowserStyle.merge, {
                hd: itemListContainerBase,
                tl: {
                  hd: Curry._1(BrowserStyle.style, {
                        hd: BrowserStyle.borderBottomLeftRadius(BrowserStyle.rem(0.25)),
                        tl: {
                          hd: BrowserStyle.borderBottomRightRadius(BrowserStyle.rem(0.25)),
                          tl: /* [] */0
                        }
                      }),
                  tl: /* [] */0
                }
              });
  }
}

var Styles$3 = {
  container: container$3,
  itemListContainerBase: itemListContainerBase,
  itemListContainer: itemListContainer
};

function BrowserComponents_Dropdown$ItemContainer(Props) {
  var bottomActions = Props.bottomActions;
  var children = Props.children;
  var className = Props.className;
  var containerClassName = Props.containerClassName;
  var label = Props.label;
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : /* Medium */2;
  var tmp = {
    className: BrowserStyle.Utils.extendBaseStyle(container$3, className),
    containerClassName: (function (param) {
        return BrowserStyle.Utils.extendBaseStyle(itemListContainer(size), containerClassName);
      }),
    children: {
      TAG: /* Static */0,
      _0: children
    },
    size: size
  };
  if (bottomActions !== undefined) {
    tmp.bottomActions = Caml_option.valFromOption(bottomActions);
  }
  if (label !== undefined) {
    tmp.label = Caml_option.valFromOption(label);
  }
  return React.createElement(BrowserComponents_Field.make, tmp);
}

var ItemContainer = {
  Styles: Styles$3,
  make: BrowserComponents_Dropdown$ItemContainer
};

function select(size, styleType) {
  return Curry._1(BrowserStyle.merge, {
              hd: Curry._2(BrowserComponents_Input.Base.Styles.input, size, styleType),
              tl: {
                hd: Curry._1(BrowserStyle.style, {
                      hd: BrowserStyle.unsafe("-webkit-appearance", "none"),
                      tl: /* [] */0
                    }),
                tl: /* [] */0
              }
            });
}

var Styles$4 = {
  select: select
};

function BrowserComponents_Dropdown$Native(Props) {
  var autoFocus = Props.autoFocus;
  var className = Props.className;
  var disabledOpt = Props.disabled;
  var hint = Props.hint;
  var icon = Props.icon;
  var items = Props.items;
  var itemToDisplayString = Props.itemToDisplayString;
  var itemToValue = Props.itemToValue;
  var onBlur = Props.onBlur;
  var onChange = Props.onChange;
  var onFocus = Props.onFocus;
  var sizeOpt = Props.size;
  var testId = Props.testId;
  var theme = Props.theme;
  var title = Props.title;
  var titleIcon = Props.titleIcon;
  var validationStatus = Props.validationStatus;
  var value = Props.value;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : /* Medium */2;
  var tmp = {
    children: {
      TAG: /* Input */1,
      _0: (function (param) {
          var onFocus = param.onFocus;
          var onBlur = param.onBlur;
          var tmp = {
            className: select(size, param.styleType),
            disabled: disabled,
            type: "text",
            onFocus: (function (param) {
                return Relude_Globals.$great$great(onFocus, IOUtils.unsafeRunHandledAsync, param);
              }),
            onBlur: (function (param) {
                return IOUtils.unsafeRunHandledAsync(onBlur);
              }),
            onChange: (function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(DomUtils.getValueFromEvent, onChange, param);
                            }), IOUtils.unsafeRunHandledAsync, param);
              })
          };
          if (autoFocus !== undefined) {
            tmp.autoFocus = Caml_option.valFromOption(autoFocus);
          }
          if (value !== undefined) {
            tmp.value = Caml_option.valFromOption(value);
          }
          var tmp$1 = {
            children: React.createElement("select", tmp, React.createElement(ReactUtils.A.make, {
                      children: Relude_Array.mapWithIndex((function (item, index) {
                              return React.createElement("option", {
                                          key: String(index),
                                          value: Curry._1(itemToValue, item)
                                        }, Curry._1(itemToDisplayString, item));
                            }), items)
                    }))
          };
          if (testId !== undefined) {
            tmp$1.id = Caml_option.valFromOption(testId);
          }
          return React.createElement(ReactUtils.WithTestId.make, tmp$1);
        })
    },
    disabled: disabled,
    size: size
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (hint !== undefined) {
    tmp.hint = Caml_option.valFromOption(hint);
  }
  if (icon !== undefined) {
    tmp.iconLeft = Caml_option.valFromOption(icon);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (theme !== undefined) {
    tmp.theme = Caml_option.valFromOption(theme);
  }
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  if (titleIcon !== undefined) {
    tmp.titleIcon = Caml_option.valFromOption(titleIcon);
  }
  if (validationStatus !== undefined) {
    tmp.validationStatus = Caml_option.valFromOption(validationStatus);
  }
  return React.createElement(BrowserComponents_Field.make, tmp);
}

var Native = {
  Styles: Styles$4,
  make: BrowserComponents_Dropdown$Native
};

var container$4 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.cursor(BrowserStyle.pointer),
      tl: /* [] */0
    });

var Styles$5 = {
  container: container$4
};

function BrowserComponents_Dropdown$Field(Props) {
  var buttonClassName = Props.buttonClassName;
  var buttonContent = Props.children;
  var className = Props.className;
  var collapseOnClickInsideOpt = Props.collapseOnClickInside;
  var disabledOpt = Props.disabled;
  var dropdownClassName = Props.dropdownClassName;
  var dropdownContent = Props.dropdownContent;
  var hint = Props.hint;
  var iconColor = Props.iconColor;
  var icon = Props.icon;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onFocus = Props.onFocus;
  var statusOverride = Props.statusOverride;
  var sizeOpt = Props.size;
  var title = Props.title;
  var validationStatus = Props.validationStatus;
  var collapseOnClickInside = collapseOnClickInsideOpt !== undefined ? collapseOnClickInsideOpt : true;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : /* Medium */2;
  var match = useExpandedState(statusOverride, collapseOnClickInside, disabled, onClick);
  var status = match.status;
  var onClick$1 = match.onClick;
  var tmp = {
    className: BrowserStyle.Utils.extendBaseStyle(container$4, Relude_Option.apply(className, Relude_Option.pure(status))),
    children: {
      TAG: /* Input */1,
      _0: (function (param) {
          var onBlur = param.onBlur;
          var tmp = {
            buttonContent: buttonContent,
            children: dropdownContent,
            containerDomRef: param.fieldContainerDomRef,
            onBlur: (function (param) {
                return Relude_Globals.$$const(onBlur, param);
              }),
            onClick: onClick$1,
            onFocus: param.onFocus,
            status: status,
            styleType: param.styleType
          };
          if (buttonClassName !== undefined) {
            tmp.className = Caml_option.valFromOption(buttonClassName);
          }
          if (dropdownClassName !== undefined) {
            tmp.containerClassName = Caml_option.valFromOption(dropdownClassName);
          }
          return React.createElement(BrowserComponents_Dropdown$Base$Stateless, tmp);
        })
    },
    disabled: disabled,
    iconRight: Curry._2(eq, /* Expanded */0, status) ? ({
          TAG: /* Arrow */0,
          _0: /* ChevronTop */14
        }) : ({
          TAG: /* Arrow */0,
          _0: /* ChevronBottom */10
        }),
    size: size
  };
  if (hint !== undefined) {
    tmp.hint = Caml_option.valFromOption(hint);
  }
  if (iconColor !== undefined) {
    tmp.iconColor = Caml_option.valFromOption(iconColor);
  }
  if (icon !== undefined) {
    tmp.iconLeft = Caml_option.valFromOption(icon);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  if (validationStatus !== undefined) {
    tmp.validationStatus = Caml_option.valFromOption(validationStatus);
  }
  return React.createElement(BrowserComponents_Field.make, tmp);
}

var Field = {
  Styles: Styles$5,
  make: BrowserComponents_Dropdown$Field
};

function container$5(isLoading) {
  if (isLoading) {
    return Curry._1(BrowserStyle.style, {
                hd: BrowserStyle.animation(500, undefined, BrowserStyle.alternate, BrowserStyle.easeIn, undefined, undefined, BrowserStyle.infinite, Curry._1(BrowserStyle.keyframes, {
                          hd: [
                            0,
                            {
                              hd: BrowserStyle.opacity(0.66),
                              tl: /* [] */0
                            }
                          ],
                          tl: {
                            hd: [
                              1,
                              {
                                hd: BrowserStyle.opacity(0.33),
                                tl: /* [] */0
                              }
                            ],
                            tl: /* [] */0
                          }
                        })),
                tl: /* [] */0
              });
  } else {
    return Curry._1(BrowserStyle.style, /* [] */0);
  }
}

function text$1(size) {
  var arg = BrowserStyle.Input.sizeToFontSize(size);
  var arg$1 = function (param) {
    return BrowserStyle.withFont(param, /* OpenSans */1, arg, /* Semibold */1);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined), {
                  hd: BrowserStyle.paddingBottom(BrowserStyle.rem(0.125)),
                  tl: {
                    hd: BrowserStyle.paddingTop(BrowserStyle.rem(0.125)),
                    tl: {
                      hd: BrowserStyle.overflow(BrowserStyle.hidden),
                      tl: {
                        hd: BrowserStyle.textOverflow(BrowserStyle.ellipsis),
                        tl: {
                          hd: BrowserStyle.whiteSpace(BrowserStyle.nowrap),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }));
}

var Styles$6 = {
  container: container$5,
  text: text$1
};

function itemArrayToCommaSeparatedString(defaultEmptyText, isItemSelected, itemToDisplayString) {
  var partial_arg = Curry._2(Relude_Array.foldLeft, (function (prim, prim$1) {
          return prim + prim$1;
        }), "");
  var partial_arg$1 = Curry._1(Relude_Array.map, itemToDisplayString);
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Array.keep(isItemSelected, param);
                }), partial_arg$1, param);
  };
  var partial_arg$3 = function (param) {
    return Relude_Globals.$great$great(partial_arg$2, (function (param) {
                  return Relude_Array.intersperse(", ", param);
                }), param);
  };
  var partial_arg$4 = function (param) {
    return Relude_Globals.$great$great(partial_arg$3, partial_arg, param);
  };
  var partial_arg$5 = function (param) {
    return Relude_Globals.$great$great(partial_arg$4, Relude_String.toNonWhitespace, param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$5, (function (param) {
                  return Relude_Option.getOrElse(defaultEmptyText, param);
                }), param);
  };
}

function itemArrayToReactComponentArray(isItemSelected, itemSelectedIcon, itemToDisplayString, itemToIcon, onSelectItem, size) {
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Array.mapWithIndex((function (item, index) {
                                var tmp = {
                                  children: Curry._1(itemToDisplayString, item),
                                  isSelected: Curry._1(isItemSelected, item),
                                  onSelectItem: Curry._1(onSelectItem, item),
                                  size: size,
                                  key: Relude_Int.toString(index)
                                };
                                var tmp$1 = Relude_Option.map((function (itemToIcon) {
                                        return Curry._1(itemToIcon, item);
                                      }), itemToIcon);
                                if (tmp$1 !== undefined) {
                                  tmp.icon = Caml_option.valFromOption(tmp$1);
                                }
                                if (itemSelectedIcon !== undefined) {
                                  tmp.selectedIcon = Caml_option.valFromOption(itemSelectedIcon);
                                }
                                return React.createElement(BrowserComponents_Dropdown$Item, tmp);
                              }), param);
                }), (function (prim) {
                  return prim;
                }), param);
  };
}

function BrowserComponents_Dropdown(Props) {
  var buttonClassName = Props.buttonClassName;
  var childrenOpt = Props.children;
  var className = Props.className;
  var collapseOnClickInsideOpt = Props.collapseOnItemSelect;
  var defaultEmptyTextOpt = Props.defaultEmptyText;
  var disabledOpt = Props.disabled;
  var dropdownClassName = Props.dropdownClassName;
  var hint = Props.hint;
  var icon = Props.icon;
  var iconColor = Props.iconColor;
  var isItemSelected = Props.isItemSelected;
  var items = Props.items;
  var itemSelectedIcon = Props.itemSelectedIcon;
  var itemToDisplayString = Props.itemToDisplayString;
  var itemToIcon = Props.itemToIcon;
  var onBlur = Props.onBlur;
  var onClick = Props.onClick;
  var onFocus = Props.onFocus;
  var onSelectItem = Props.onSelectItem;
  var statusOverride = Props.statusOverride;
  var sizeOpt = Props.size;
  var testId = Props.testId;
  var title = Props.title;
  var validationStatus = Props.validationStatus;
  var children = childrenOpt !== undefined ? childrenOpt : /* Items */0;
  var collapseOnClickInside = collapseOnClickInsideOpt !== undefined ? collapseOnClickInsideOpt : true;
  var defaultEmptyText = defaultEmptyTextOpt !== undefined ? defaultEmptyTextOpt : "None";
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : /* Medium */2;
  var match = ReactIO.useState(function (param) {
        return false;
      });
  var setCurrentlyRunningIO = match[1];
  var currentlyRunningIO = match[0];
  var onSelectItem$1 = function (item) {
    return Relude_IO.catchError((function (e) {
                  return Relude_IO.flatMap((function (param) {
                                return Relude_IO.$$throw(e);
                              }), Curry._1(setCurrentlyRunningIO, false));
                }), Relude_IO.flatMap((function (param) {
                      return Curry._1(setCurrentlyRunningIO, false);
                    }), Relude_IO.flatMap((function (param) {
                          return Curry._1(onSelectItem, item);
                        }), Curry._1(setCurrentlyRunningIO, true))));
  };
  var isLoading;
  switch (items.TAG | 0) {
    case /* AsyncSet */0 :
        isLoading = Relude_AsyncResult.isBusy(items._0);
        break;
    case /* List */1 :
    case /* Set */2 :
        isLoading = false;
        break;
    
  }
  var itemArrayToCommaSeparatedString$1 = itemArrayToCommaSeparatedString(defaultEmptyText, isItemSelected, itemToDisplayString);
  var itemArrayToReactComponentArray$1 = itemArrayToReactComponentArray(isItemSelected, itemSelectedIcon, itemToDisplayString, itemToIcon, onSelectItem$1, size);
  var tmp;
  if (children) {
    tmp = children._0;
  } else {
    switch (items.TAG | 0) {
      case /* AsyncSet */0 :
          tmp = Relude_AsyncResult.foldByValue("Loading...", (function (param) {
                  return Relude_Globals.$great$great(Relude_Set.toArray, itemArrayToCommaSeparatedString$1, param);
                }), (function (param) {
                  return Relude_Globals.$$const("Error", param);
                }), items._0);
          break;
      case /* List */1 :
          tmp = Curry._1(itemArrayToCommaSeparatedString$1, Relude_List.toArray(items._0));
          break;
      case /* Set */2 :
          tmp = Curry._1(itemArrayToCommaSeparatedString$1, Relude_Set.toArray(items._0));
          break;
      
    }
  }
  var tmp$1;
  switch (items.TAG | 0) {
    case /* AsyncSet */0 :
        tmp$1 = Relude_Option.fold(null, (function (param) {
                return Relude_Globals.$great$great(Relude_Set.toArray, itemArrayToReactComponentArray$1, param);
              }), Relude_AsyncResult.getOk(items._0));
        break;
    case /* List */1 :
        tmp$1 = Curry._1(itemArrayToReactComponentArray$1, Relude_List.toArray(items._0));
        break;
    case /* Set */2 :
        tmp$1 = Curry._1(itemArrayToReactComponentArray$1, Relude_Set.toArray(items._0));
        break;
    
  }
  var tmp$2 = {
    children: React.createElement(BrowserComponents_Text.make, {
          className: text$1(size),
          children: tmp
        }),
    className: (function (status) {
        return BrowserStyle.Utils.extendBaseStyle(container$5(isLoading || currentlyRunningIO), Relude_Option.map((function (className) {
                          return Curry._2(className, isLoading || currentlyRunningIO, status);
                        }), className));
      }),
    collapseOnClickInside: collapseOnClickInside,
    disabled: disabled || isLoading || currentlyRunningIO,
    dropdownContent: React.createElement(BrowserComponents_Dropdown$ItemContainer, {
          children: tmp$1,
          size: size
        }),
    size: size
  };
  if (buttonClassName !== undefined) {
    tmp$2.buttonClassName = Caml_option.valFromOption(buttonClassName);
  }
  if (dropdownClassName !== undefined) {
    tmp$2.dropdownClassName = Caml_option.valFromOption(dropdownClassName);
  }
  if (hint !== undefined) {
    tmp$2.hint = Caml_option.valFromOption(hint);
  }
  if (iconColor !== undefined) {
    tmp$2.iconColor = Caml_option.valFromOption(iconColor);
  }
  if (icon !== undefined) {
    tmp$2.icon = Caml_option.valFromOption(icon);
  }
  if (onBlur !== undefined) {
    tmp$2.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onClick !== undefined) {
    tmp$2.onClick = Caml_option.valFromOption(onClick);
  }
  if (onFocus !== undefined) {
    tmp$2.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (statusOverride !== undefined) {
    tmp$2.statusOverride = Caml_option.valFromOption(statusOverride);
  }
  if (title !== undefined) {
    tmp$2.title = Caml_option.valFromOption(title);
  }
  if (validationStatus !== undefined) {
    tmp$2.validationStatus = Caml_option.valFromOption(validationStatus);
  }
  var tmp$3 = {
    children: React.createElement(BrowserComponents_Dropdown$Field, tmp$2)
  };
  if (testId !== undefined) {
    tmp$3.id = Caml_option.valFromOption(testId);
  }
  return React.createElement(ReactUtils.WithTestId.make, tmp$3);
}

var make = BrowserComponents_Dropdown;

exports.Status = Status;
exports.Orientation = Orientation;
exports.Base = Base;
exports.Item = Item;
exports.ItemContainer = ItemContainer;
exports.Native = Native;
exports.Field = Field;
exports.Styles = Styles$6;
exports.itemArrayToCommaSeparatedString = itemArrayToCommaSeparatedString;
exports.itemArrayToReactComponentArray = itemArrayToReactComponentArray;
exports.make = make;
/* include Not a pure module */
